<script lang="ts">
	import Info from '@lucide/svelte/icons/info'
	import TriangleAlert from '@lucide/svelte/icons/triangle-alert'

	import { phg } from '#lib/utils/posthog.js'

	let {
		content,
		ariaLabel,
		type = 'info',
	}: {
		content?: Nullable<string>
		ariaLabel?: Nullable<string>
		type?: 'info' | 'warning'
	} = $props()

	let open = $state(false)
	let customAnchor = $state<Nullable<HTMLElement>>(null)
</script>

{#if content}
	<button
		bind:this={customAnchor}
		class="focus-visible:ring-ring inline-flex size-4 items-center justify-center rounded-full p-0.5 focus-visible:ring-3 {type ===
		'info'
			? 'text-muted-foreground hover:text-foreground'
			: 'text-orange-400 hover:text-orange-500'}"
		aria-label={ariaLabel}
		onclick={() => {
			open = true

			phg.capture('info_popover_open')
		}}
		type="button"
	>
		{#if type === 'info'}
			<Info />
		{:else}
			<TriangleAlert />
		{/if}
	</button>

	{#if open}
		{#await import('#lib/components/ui/popover/index.js') then Popover}
			<Popover.Root bind:open>
				<Popover.Portal>
					<Popover.Content
						class="links-inside w-auto max-w-80 p-2 text-sm"
						{customAnchor}
						side="top"
					>
						<!-- eslint-disable-next-line svelte/no-at-html-tags -->
						{@html content}
					</Popover.Content>
				</Popover.Portal>
			</Popover.Root>
		{/await}
	{/if}
{/if}
